import React from 'react'

export default class Privacy extends React.Component{
    render(){
        return (
            <div><p>privacy policy ....</p></div>
        )
    }
}